/* eslint-disable */
export default {
  contactDetails: 'Contactgegevens',
  loadingContact: 'Contactpersoon wordt geladen...',
  contactNotFound: 'Contactpersoon niet gevonden.',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
